__webpack_require__.p = "/reports-resize-on-sidebar-changes/referrals-hub/";